<template>
  <td :colspan="colspan" class="text-left date-column">
    <v-dialog
      ref="dialog"
      v-model="modal"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          outlined
          v-bind="attrs"
          v-on="on"
        >
          {{ value }}
        </v-btn>
      </template>
      <v-date-picker
        v-model="date"
        :first-day-of-week="1"
        :events="checkDays"
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="save"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </td>
</template>

<script>
export default {
  name: 'DateColumn',
  props: {
    colspan: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      modal: false,
      loading: false,
      date: this.value,
      days: null
    }
  },
  watch: {
    value (newDate) {
      this.date = newDate
    }
  },
  async mounted () {
    this.loading = true
    const { data } = await this.$axios.get(`${this.$store.getters.projectPath}/builds/days`)
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.days = data
    }

    this.loading = false
  },
  methods: {
    close () {
      this.modal = false
    },
    save () {
      this.$emit('input', this.date)
      this.close()
    },
    checkDays (date) {
      if (!this.days) return false

      const colors = []

      const day = this.days.find(d => d.date === date)
      if (day) {
        colors.push('primary')

        if (day.has_playtest) {
          colors.push('red')
        }
      }

      if (colors.length) {
        return colors
      } else {
        return false
      }
    }
  }
};
</script>